import React, { useState } from 'react';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import ModalAddRatePlan from 'screens/ModalAddRatePlan';
import { useQuery } from '@apollo/client';
import { GET_ALL_RATE_PLANS } from 'graphql/service';
import { RatePlanTableContainer } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const HotelInfoAndPolicies = () => {


  return (
    <Card>
      <CardHeader>
        <div className='type'>CURRENT RATE PLAN</div>
        <div className='buttonContainer'>
          <ModalAddRatePlan

          />
        </div>
      </CardHeader>
      <div>
        “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. culpa qui officia deserunt mollierunt mollie.” 
      </div>
    </Card>
  );
};

export default HotelInfoAndPolicies;
